import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { localStateSelector, makeOfferSettingsSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  includeOffer: boolean;
  onChange: (includeOffer: boolean) => void;
};
const makeMapStateToProps = () => {
  const offerSettingsSelector = makeOfferSettingsSelector();

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);
    const offerSettings = offerSettingsSelector(state, props);
    return {
      ...props,
      isEditMode: state.isEditMode,
      item: localState.cart.offerItem,
      currencyCode: localState.currencyCode,
      noImageUrl: getNoImageUrl(),
      settings: offerSettings
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onChange: props.onChange
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
